import { ActionTypes } from './constants'
import type { AuthActions, AuthState } from './types'

const init: AuthState = {
  user: null,
  loading: false,
  error: '',
  userActive: true,
  seenPopups: null,
}

const auth = (state = init, action: AuthActions): AuthState => {
  switch (action.type) {
    case ActionTypes.USER_ACTIVITY: {
      return {
        ...state,
        userActive: action.payload.isUserActive,
      }
    }

    case ActionTypes.GET_USER_SETTINGS_SUCCESS: {
      return {
        ...state,
        seenPopups: action.payload.settings.seenPopups || null,
        loading: false,
      }
    }

    case ActionTypes.UPDATE_USER_SETTINGS_SUCCESS: {
      return {
        ...state,
        seenPopups: action.payload.settings.seenPopups || null,
      }
    }

    case ActionTypes.GET_USER_PROFILE_SUCCESS: {
      // Merge trade / phoneNumber onto the existing user (populated at login from Firebase).
      if (!state.user) return state
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload.profile,
        },
      }
    }

    case ActionTypes.AUTH_REQUEST: {
      return {
        ...state,
        loading: true,
      }
    }

    case ActionTypes.AUTH_LOG_IN: {
      return {
        ...state,
        user: action.payload.user,
      }
    }

    case ActionTypes.AUTH_ERROR: {
      return {
        ...state,
        loading: false,
        user: null,
        error: action.payload.message,
      }
    }

    case ActionTypes.AUTH_LOG_OUT: {
      return {
        user: null,
        loading: false,
        error: '',
        userActive: false,
      }
    }

    default:
      return state
  }
}

export default auth
